import { render, staticRenderFns } from "./TableVersionHistory.vue?vue&type=template&id=2ea6be6f&scoped=true&"
import script from "./TableVersionHistory.vue?vue&type=script&lang=js&"
export * from "./TableVersionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TableVersionHistory.vue?vue&type=style&index=0&id=2ea6be6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6be6f",
  null
  
)

export default component.exports